<template>
  <div
    class="Content__DocumentEmpty mx-auto mt-8 lg:mt-0"
    id="approve-or-disapprove"
    v-if="approver"
  >
    <div class="flex items-center justify-center lg:justify-end space-x-3">
      <!-- todo date format -->
      <span v-if="approver.disapproved" class="text-red-600">{{$t('You already disapproved document on %date%', {date: formatDate(approver.disapproved, 'd. m. y')})}}</span>
      <span v-if="approver.approved" class="text-green-600">{{$t('You already approved document on %date%', {date: formatDate(approver.approved, 'd. m. y')})}}</span>
      <a 
        v-if="!approver.disapproved && !edit" 
        href="" 
        class="btn btn-danger btn-lg inline-flex items-center" 
        @click.stop.prevent="approve(false)"
      >
        <aw-icon 
          icon="close" 
          class="w-4.5 h-4.5 mr-1 -my-1"
        />
        {{ $t('Disapprove') }}
      </a>
      <a 
        v-if="!approver.approved && !edit" 
        href=""
        class="btn btn-success btn-lg inline-flex items-center" 
        @click.stop.prevent="approve(true)"
      >
        <aw-icon 
          icon="tick" 
          class="w-4.5 h-4.5 mr-1"
        />
        {{ $t('Approve') }}
      </a>
    </div>
  </div>
</template>

<script>
import { showPrompt } from '../BcPrompt'
import { DocumentApi } from '../../test-api/index.ts'
import DocumentStore from '../../mixins/DocumentStore'

const documentApi = new DocumentApi({}, '/api/v2')
import handleApiError from '../../utils/handleApiError'

export default {
  mixins: [
    DocumentStore,
  ],
  props: {
    approval: Object,
    document: Object,
    edit: Boolean,
  },
  computed: {
    canIApprove() {
      return this.approval.state && this.approver
    },
    approver() {
      if ((this.getIApprovers.length)) {
        return this.getIApprovers[0]
      }

      return null
    },
    getIApprovers() {
      return this.approval.approvers.filter((u) => u.user.id === this.$presenter.identity.id)
    },
  },
  methods: {
    async approve(approved) {
      const promptResult = await showPrompt({
        header: approved ? this.$t('Do you wanna leave a comment?') : this.$t('Please add comment for your disapproval'),
        buttonNo: 'Cancel',
        buttonYes: approved ? 'Approve' : 'Disapprove',
        class: approved ? 'btn-success' : 'btn-danger',
        required: approved ? null : true,
        value: this.approver.note,
      })

      if (promptResult === false) {
        return
      }

      const approveResponse = await handleApiError(() => documentApi.documentApprove(this.document.id, { approved, note: promptResult }))
      this.bcDocumentStore.document.approval = approveResponse.data
    }
  }
}
</script>

<style lang="scss" scoped></style>
